import React from 'react'

import resolveProps from '../../../utils/resolveProps'

import { HeadingOwnProps, HeadingSizes } from './types'

type HeadingProps<E extends React.ElementType> = HeadingOwnProps<E> &
  Omit<React.ComponentProps<E>, keyof HeadingOwnProps>;

const configs = {
  types: ['inverse'],
  modifiers: [
    'xxs',
    'xs',
    'sm',
    {
      title: 'md',
      isDefault: true
    },
    'lg',
    'xl',
    'xxl'
  ]
}
const defaultElement = "h1";



function Heading<E extends React.ElementType = typeof defaultElement>
  (props: HeadingProps<E> & (HeadingSizes)) {

  const {
    children,
    xxs = false,
    xs = false,
    sm = false,
    md = false,
    lg = false,
    xl = false,
    xxl = false,
    inverse = false,
    tag,
    ...rest
  } = props

  const CustomTag = tag || 'h1'

  return (
    <CustomTag {...rest} className={resolveProps(props, configs, 'Heading')}>
      {children}
    </CustomTag>
  )
}



export default Heading
